import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    rowGap: "20px",
    "@media (min-width: 500px)": {
      width: "60%",
      justifyContent: "flex-start",
      ...shorthands.padding("12px"),
      ...shorthands.gap("12px"),
    },
  },
  image: {
    width: "100%",
    maxWidth: "200px",
  },
  fullWidth: {
    width: "100%",
    "@media (min-width: 500px)": {
      width: "100%",
      justifyContent: "flex-start",
      ...shorthands.padding("12px"),
      ...shorthands.gap("12px"),
    },
  },
});
